<template>
  <div v-if="btnSpec.btnType === 'icon'">
    <v-btn
      :loading="loading"
      :color="ui.bkgdColor"
      @click="spin()"
      icon
    >
    <v-icon left> {{btnSpec.icon}} </v-icon>
      {{btnSpec.name}}
    </v-btn>
  </div>
  <div v-else-if="btnSpec.btnType === 'block'">
    <v-btn
      :loading="loading"
      :color="btnSpec.color"
      @click="spin()"
      block
    >
    <v-icon left> {{btnSpec.icon}} </v-icon>
      {{btnSpec.name}}
    </v-btn>
  </div>
  <div v-else-if="btnSpec.btnType === 'flat'">
    <v-btn
      :loading="loading"
      @click="spin()"
      :color="ui.btnColor"
      flat
    >
    <v-icon left> {{btnSpec.icon}} </v-icon>
      {{btnSpec.name}}
    </v-btn>
  </div>
  <div v-else-if="btnSpec.btnType === 'outline'">
    <v-btn
      :loading="loading"
      color="red"
      @click="spin()"
      outline
    >
    <v-icon left> {{btnSpec.icon}} </v-icon>
      {{btnSpec.name}}
    </v-btn>
  </div>
  <div v-else>
    <v-btn
      :loading="loading"
      :color="btnSpec.color"
      @click="spin()"
      flat
    >
    <v-icon left> {{btnSpec.icon}} </v-icon>
      {{btnSpec.name}}
    </v-btn>
  </div>
</template>

<script>
import uisettings from "@/frame/theme/mixins/uisettings.js";
import { mapGetters } from "vuex";
/* eslint-disable */
  export default {
    mixins: [uisettings],
    props: {
      btnSpec: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        loader: null,
        loading: true
      }
    },
    computed: {
      ...mapGetters(["getBtnSpinEnabled"]),
      ui() {
        return this.uiTheme1;
      }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]
        setTimeout(() => (this[l] = false), 3000)
        this.loader = null
        // this[l] = false
      },
      getBtnSpinEnabled () {
        // spin button
        this.loader = null;
        this.loading = false;
      }
    },
    methods: {
      spin() {
        this.loader = 'loading'
        // this.loader = false
      }
    }
  }
</script>

<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
